const allapprovals = { data: [], loading: true };

export const GetAllApprovalsRed = (state = allapprovals, action) => {
  switch (action.type) {
    case "get_allapprovals":
      return {
        data: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};
